import { render, staticRenderFns } from "./PageBlocks.vue?vue&type=template&id=70fb786a&scoped=true&"
import script from "./PageBlocks.vue?vue&type=script&lang=js&"
export * from "./PageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./PageBlocks.vue?vue&type=style&index=0&id=70fb786a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb786a",
  null
  
)

component.options.__file = "PageBlocks.vue"
export default component.exports